var radio = require("react-pubsub-via-radio.js/radio");
var _ = require('lodash');
var Balboa = require('./Balboa');
var esUtils = require('../utils/esUtils');

var cached_response = null;

var ask_balboa = (function(){
	var currently_talking_to_balboa = false;
	return function(){
		if(currently_talking_to_balboa){
			return;
		}
		currently_talking_to_balboa = true;
		Balboa.api('/mpmessage/numunread', {
			get_by_eid_then_sid: true
		}, function(data){
			cached_response = data.data;
			radio('unread_messages_by_eid_and_sid').broadcast(cached_response);
			currently_talking_to_balboa = false;
		}, function(data){
			console.error(data);
			currently_talking_to_balboa = false;
		});
	};
}());


var markAsRead = (function(){
	var message_ids_marked_as_read = [];
	return function(message_ids){
		message_ids = esUtils.cleanup_ids(message_ids);
		message_ids = _.difference(message_ids, message_ids_marked_as_read);
		if(message_ids.length === 0){
			return;
		}
		Balboa.api('/mpmessage/ireadit', {
			ids: message_ids
		}, function(data){
			message_ids_marked_as_read.concat(message_ids);
			radio('messages_marked_as_read').broadcast(message_ids);
			ask_balboa();//re-broadcast it
		}, function(data){
			console.error(data);
		});
	};
}());

module.exports.init = function(){
	radio('please_broadcast_number_of_unread_messages').subscribe(_.debounce(function(){
		if(cached_response){
			radio('unread_messages_by_eid_and_sid').broadcast(cached_response);
		}else{
			ask_balboa();
		}
	}, 100));
	setTimeout(ask_balboa, 10 * 60 * 1000);//check every 10 min

	var message_ids_to_mark_read = [];
	radio('mark_messages_as_read').subscribe(function(mp_message_ids){
		message_ids_to_mark_read = message_ids_to_mark_read.concat(esUtils.cleanup_ids(mp_message_ids));
		_.debounce(function(){
			markAsRead(message_ids_to_mark_read);
		}, 100)();
	});

};



//////////////////
// WEBPACK FOOTER
// ./~/ES/services/UnreadMessages.js
// module id = 183
// module chunks = 0 1 2 3 4